var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"result-item"},[_c('Amount',[_c(_vm.icon,{tag:"component",staticClass:"icon"}),_vm._v(" "+_vm._s(_vm.amount))],1),_c('Description',[_vm._v(_vm._s(_vm.description))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }